import { IS_IOS_CHROME, IS_IOS_FIREFOX } from '../common/constants';

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const saveFile = (url: any, fileName: string, downloadFile: any) => {
  if (IS_IOS_CHROME || IS_IOS_FIREFOX) {
    const out = new Blob([downloadFile], { type: 'application/pdf' });
    const fileURL = (window.URL || window['webkitURL']).createObjectURL(out);
    const downloadLink = document.createElement('a');
    downloadLink.href = fileURL;
    downloadLink.target = '_blank';
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    setTimeout(() => {
      document.body.removeChild(downloadLink);
    }, 100);

    return;
  }
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.append(link);
  link.click();
  link.remove();
  window.addEventListener('focus', (_e) => URL.revokeObjectURL(url), { once: true });
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default saveFile;
